import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex items-center mx-4 my-2 text-gray-400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col justify-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "mr-3" }, "Filter by")
], -1)
const _hoisted_4 = { class: "text-sm font-light text-white select-none" }
const _hoisted_5 = { class: "w-40 h-10 p-2 m-4 rounded grid-component-parent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_grid_component = _resolveComponent("grid-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (filter) => {
        return (_openBlock(), _createBlock("div", {
          onClick: ($event: any) => (_ctx.handleFilterClick(filter)),
          key: filter.value,
          class: [` ${
          filter.value === _ctx.activeValue
            ? filter.styles.borderColor + ' border-2'
            : 'border-gray-600 border'
        }`, "flex items-center p-2 m-2 rounded-md cursor-pointer"],
          "data-testid": `filter-${filter.value}`
        }, [
          _createVNode(_component_icon_component, {
            icon: filter.icon,
            class: "w-4 h-4 mr-2"
          }, null, 8, ["icon"]),
          _createVNode("div", _hoisted_4, _toDisplayString(filter.label), 1)
        ], 10, ["onClick", "data-testid"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_grid_component, { gridElements: _ctx.gridData }, null, 8, ["gridElements"])
    ])
  ]))
}